import { queryIframeContent } from '@utils/query';

export const injectIframeStyles = () => {
	const doc = queryIframeContent();

	if (!doc) {
		return;
	}

	const id = 'ea11y-highlighter-styles';
	let style = doc.getElementById(id);

	if (!style) {
		style = doc.createElement('style');
		style.id = id;

		style.textContent = `
			.ea11y-scanner-background-element,
			.ea11y-scanner-color-element,
			.ea11y-scanner-current-element {
				box-shadow: 0 0 0 4px #2563EB;
				border-radius: 4px;
				transition: 300ms ease-in-out;
			}
		`;

		(doc.head || doc.body || doc.documentElement).appendChild(style);
	}
};
